export default __webpack_public_path__ + "static/media/korea.6513a252.jpg";